<template>
   <section
    v-if="variants.v1 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
  <div class="container">
    
  <BlockSymbol :position-text="String(vars?.blockPositionText || '')" :block-color="String(vars?.blockColor || '')" />
    <div
      class=""
    >
      
    <div class="row justify-between items-center">
      <div class="col-auto" v-html="vars.titleHtml"></div>

          <div class="col-xl-6 md:d-none">
            <p>{{vars.descriptionText}}</p>
          </div>
        </div>
    </div>
    <div v-if="isBlogsLoading">
      <loader loader-color="var(--c-primary)" />
    </div>
    <div class="tw-relative tw-w-full">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="3"
        :space-between="30"
        :loop="true"
        effect="fade"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1336: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class="tw-w-full"
      >
        <SwiperSlide
          v-for="(blog, index) in blogs"
          :key="`blog-${index}`"
          class="tw-flex tw-items-center tw-justify-center"
          :delay="index * 250"
        >
          <Theme7BlogsBlogCard :blog="blog" :index="index" :component="component" />
        </SwiperSlide>
      </Swiper>
      <LibrarySliderPagination
        :swiper="swiper"
        variant="v4"
        :can-paginate-back="canPaginateBack"
        :can-paginate-next="canPaginateNext"
      />
    </div>
  </div>
    
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import type { Component } from '~/types';
import indexGlobal from '~/mixins/index.global';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';
import Loader from '~/components/common/Loader.vue';
import BlockSymbol from '~/components/common/BlockSymbol.vue';
export default defineNuxtComponent({
  name: 'Theme7OurBlog',

  mixins: [BlogsMixin, indexGlobal, ComponentMixin],

  components: {
    Loader,
    BlockSymbol,
  },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,

      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchBlogsInPage(props.component);
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    ROUTES() {
      return ROUTES;
    },
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },
  mounted() {
    this.onSlideChange();
  },
});
</script>
<style scoped>
.block {
  font-size: 24em;
  font-weight: 900;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: 1;
  margin: 0;
  padding: 0;
  position: absolute;
}
</style>